import { Auth } from "aws-amplify";

export const isAuthenticated = async (): Promise<boolean> => {
  let result = false;
  try {
    await Auth.currentAuthenticatedUser();
    result = true;
  } catch (error) {
    if (!navigator.onLine) result = true;
  }
  return result;
};
